module.exports = __webpack_public_path__ + "img/744.edc62d8a.jpg";